<div
  #container
  class="container flex row"
  [attr.contenteditable]="editMode"
  (click)="onContentEditableClick($event)"
  (keypress)="onContentEditableKeypress($event)"
  (blur)="onContentEditableBlur($event)"
  (paste)="onPaste($event)"
>
  {{ formatTime(valueMs) }}
</div>
